import React from "react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "../contexts/LanguageContext";

export const DaisyFooter = () => {
  const { language } = useLanguage();
  const whatsappMessage =
    "Hello. I would like to see your catalog of pieces. Please send me information on prices. Could you please provide information on workshops and future events?";

  return (
    <footer className="bg-stone-900 text-stone-400 mt-24 py-14 px-6">
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-6">
        <p className="text-xs tracking-[0.3em] uppercase text-gold font-light">
          TamTam Jewelry
        </p>
        <div className="w-8 h-px bg-stone-700" />
        <div className="flex items-center gap-6">
          <a
            href={`https://wa.me/+351912220302?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="hover:text-green-400 transition-colors duration-200"
          >
            <FaWhatsapp className="w-5 h-5" />
          </a>
          <a
            href="https://www.instagram.com/tamtambygs/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hover:text-pink-400 transition-colors duration-200"
          >
            <FaInstagram className="w-5 h-5" />
          </a>
        </div>
        <p className="text-xs text-stone-600 tracking-wider">
          {language === "pt"
            ? "© 2024 TamTam Jewelry. Todos os direitos reservados."
            : "© 2024 TamTam Jewelry. All rights reserved."}
        </p>
      </div>
    </footer>
  );
};

export default DaisyFooter;
